var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { Redirect, Route } from "react-router-dom";
import { connectComponent } from "../../redux/utils";
var PrivateRoute = /** @class */ (function (_super) {
    __extends(PrivateRoute, _super);
    function PrivateRoute() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrivateRoute.prototype.render = function () {
        var _a = this.props, requiredPrivileges = _a.requiredPrivileges, userPrivileges = _a.userPrivileges, Component = _a.component, redirectMap = _a.redirectMap;
        var isPrivilegeExists = false;
        if (requiredPrivileges && userPrivileges) {
            for (var _i = 0, requiredPrivileges_1 = requiredPrivileges; _i < requiredPrivileges_1.length; _i++) {
                var privilege = requiredPrivileges_1[_i];
                if (userPrivileges.aliases.indexOf(privilege) !== -1) {
                    isPrivilegeExists = true;
                    break;
                }
            }
        }
        var rest = __assign({}, this.props);
        delete rest.component;
        if (redirectMap) {
            var url_1 = '/forbidden';
            for (var _b = 0, _c = userPrivileges.aliases; _b < _c.length; _b++) {
                var alias = _c[_b];
                if (redirectMap[alias]) {
                    url_1 = redirectMap[alias];
                    break;
                }
            }
            return React.createElement(Route, __assign({}, rest, { render: function () { return (React.createElement(Redirect, { to: url_1 })); } }));
        }
        else {
            return React.createElement(Route, __assign({}, rest, { render: function (props) {
                    return isPrivilegeExists && React.createElement(Component, __assign({}, props));
                } }));
        }
    };
    return PrivateRoute;
}(Component));
export default connectComponent(function (state) { return ({
    userPrivileges: state.auth.privileges
}); }, function (dispatch) { return ({}); }, PrivateRoute);
//# sourceMappingURL=PrivateRoute.js.map